import VideoPlayer from "./VideoPlayer";

export default function LoudVideoSection({ data, className = "" }) {
  return (
    <section className={`video-section ${className ? className : ``}`}>
      <article className="container lg:text-center lg:maxw-xl fx--o-2">
        <h2
          className="text-lg"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <p
          className="lg:mt-3 md:mt-2 lg:maxw-xl lg:ml-auto lg:mr-auto lg:px-3"
          dangerouslySetInnerHTML={{ __html: data.desc }}
        />
      </article>
      <VideoPlayer
        data={data.video}
        id={data.video.id}
        iframeId="videoUtubeOne"
        videoTagId="videoTimgOne"
        wrapClass="container mt-5 md:mb-5"
        width={760}
        height={427}
      />
      <style jsx>{`
        .video-section :global(.video-highlight) {
          position: relative;
          border-radius: 8px;
          width: 760px;
          height: 427px;
        }
      `}</style>
    </section>
  );
}
